import { useRef, useEffect } from 'react'
/**
 * ScrollProgress — a 2px hairline at the top of the page that fills
 * left-to-right as the user scrolls, gradient cyan → violet → lime.
 */
export function ScrollProgress() {
  const ref = useRef()
  useEffect(() => {
    const fn = () => {
      const h   = document.documentElement
      const pct = (h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight)) * 100
      if (ref.current) ref.current.style.width = `${pct}%`
    }
    window.addEventListener('scroll', fn, { passive: true })
    fn()
    return () => window.removeEventListener('scroll', fn)
  }, [])
  return <div id="sprog" ref={ref} />
}
